import LoadJscript from "../components/LoadJscript";
const TutorFooter =() => {
    <>
    <LoadJscript/>
    </>

}
export default TutorFooter;